@charset "UTF-8";

/* src/app/shared/popups/popup-scheduling/popup-scheduling.component.scss */
:host phscw-input-date + phscw-input-date {
  margin-left: 10px;
}
:host .cw-popup-title {
  position: relative;
}
:host .cw-popup-close {
  align-items: center;
  border-radius: 30px;
  color: var(--color-primary-dark);
  cursor: pointer;
  display: flex;
  font-size: 18px;
  height: 35px;
  justify-content: center;
  position: absolute;
  right: 0;
  width: 35px;
}
:host .cw-popup-close:hover {
  border: 1px solid var(--color-primary-dark);
}
:host .cw-popup-close:active {
  background-color: var(--color-primary-dark);
  color: var(--color-default-light);
}
:host phscw-input-date ::ng-deep .cw-input-label {
  min-width: 0;
  width: 30px;
}
:host .icon-spinner {
  float: right;
  margin-top: 20px;
}
:host phscw-grid ::ng-deep > div {
  max-height: 350px;
}
:host phscw-grid ::ng-deep .cw-grid-cell-datetime {
  white-space: normal;
}
/*# sourceMappingURL=popup-scheduling.component.css.map */
